<template>
  <v-row :key="message.id + '_' + message.lastUpdatedTimestamp"
         :class="message.type === 'question' ? 'rowQuestion' : 'rowReply'" justify="center" no-gutters
         row
         wrap>
    <v-col cols="12">
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item class="px-0">
              <v-list-item-avatar :color="message.type === 'question' ? 'rowReply' : 'rowQuestion'"
                                  size="36"
                                  class="elevation-3"
                                  rounded
                                  style="align-self: start">
                <v-icon v-if="message.type === 'reply'" color="accent2">mdi
                  mdi-robot-happy
                </v-icon>
                <v-icon v-if="message.type === 'question'" color="accent2">mdi
                  mdi-account
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div style="position: relative; width: 100%;">
                  <div v-if="!!message.message" class="body-1 pr-2"
                       :class="{'text-pre-wrap': message.type !== 'reply'}">
                    <div class="pr-2">
                      <marked-wrapper :content="message.message"></marked-wrapper>
                    </div>

                    <template
                        v-if="!!message.message && message.type === 'reply' && !message.inflight && sources && sources.length && message.id !== 'disclaimer_message'">
                      <div class="pt-2 pr-4">
                        <div class="caption">{{ $t('Sources') }}:</div>
                        <v-chip v-for="source in sources" :key="source.path" :href="source.url"
                                target="_blank" :link="!!source.url" class="mr-1" small>
                          <div class="text-truncate">{{ source.path }}</div>
                        </v-chip>
                      </div>
                    </template>
                  </div>
                  <div v-else-if="message.error">
                    <v-alert type="error" prominent text class="mt-n1 mb-0" dense>
                      {{ $t('generic_error_message') }}
                    </v-alert>
                  </div>
                  <div v-else-if="loading" class="body-1">
                    <v-skeleton-loader light
                                       loading
                                       type="paragraph"></v-skeleton-loader>
                  </div>

                  <div
                      v-if="message.type === 'reply' && !!message.message && message.id !== 'disclaimer_message' && !message.inflight"
                      class="pt-3 pr-4 text-right">
                    <span class="caption mr-1">{{ $t('did_you_get_your_answer') }}</span>
                    <v-btn color="accent2 darken-4" icon small tile @click="voteUp">
                      <v-icon small v-if="message.rating === 1">mdi mdi-thumb-up</v-icon>
                      <v-icon small v-else>mdi mdi-thumb-up-outline</v-icon>
                    </v-btn>
                    <v-btn color="accent2 darken-4" icon small tile @click="voteDown">
                      <v-icon small v-if="message.rating === -1">mdi mdi-thumb-down</v-icon>
                      <v-icon small v-else>mdi mdi-thumb-down-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-list-item-content>

            </v-list-item>

            <v-alert prominent :value="message.id === 'disclaimer_message'" type="info" text class="mt-5 caption" dense>
              <p>{{ $t('ai_disclaimer_long_1') }} <a :href="disclaimerLink" target="_blank">[{{ $t('more_info') }}]</a>
              </p>
              <p>{{ $t('ai_disclaimer_long_2') }}</p>
              <p class="mb-1">{{ $t('ai_disclaimer_long_3') }}</p>
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import MarkedWrapper from "@/views/EmbedChat/components/MarkedWrapper.vue";

export default {
  name: 'chat-message-item',
  components: {MarkedWrapper},
  props: {
    message: {},
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      replyCopied: false,
    }
  },
  computed: {
    disclaimerLink() {
      switch (this.$i18n.locale) {
        case 'fi':
          return 'https://www.kirami.fi/tietosuojakaytannot';
        case 'en':
          return 'https://www.kirami.com/data-protection-policy';
        case 'se':
          return 'https://www.kirami.se/dataskyddspraxis';
        case 'de':
          return 'https://www.kirami.de/datenschutzpraxis';
        case 'fr':
          return 'https://www.kirami.fr/politique-de-protection-des-donnees';
        case 'nl':
          return 'https://www.kirami.nl/privacybeleid';
        case 'it':
          return 'https://www.kirami.com/data-protection-policy';
      }
      return 'https://www.kirami.com/data-protection-policy';
    },
    sources() {
      // Lähteet ovat aina täysiä URL:eja (sivusto tai julkinen blob)
      return (this.message.sourceUrls || []).map(url => ({path: url, url}));
    },
  },
  watch: {},
  methods: {
    voteUp() {
      this.$emit('vote-up', this.message, 1);
    },
    voteDown() {
      this.$emit('vote-down', this.message, -1);
    },
    copyReply() {
      navigator.clipboard.writeText(this.message.message)
          .then(() => {
            this.replyCopied = true;
            setTimeout(() => {
              this.replyCopied = false;
            }, 1350);
          })
          .catch(err => {
            console.error('Could not copy text: ', err);
          });
    }
  },
}
</script>
